import { render, staticRenderFns } from "./ManagingStudentInvoice.vue?vue&type=template&id=45d40041&scoped=true"
import script from "./ManagingStudentInvoice.vue?vue&type=script&lang=js"
export * from "./ManagingStudentInvoice.vue?vue&type=script&lang=js"
import style0 from "./ManagingStudentInvoice.vue?vue&type=style&index=0&id=45d40041&lang=scss&scoped=true"
import style1 from "./ManagingStudentInvoice.vue?vue&type=style&index=1&id=45d40041&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d40041",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45d40041')) {
      api.createRecord('45d40041', component.options)
    } else {
      api.reload('45d40041', component.options)
    }
    module.hot.accept("./ManagingStudentInvoice.vue?vue&type=template&id=45d40041&scoped=true", function () {
      api.rerender('45d40041', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tutition_v3/ManagingStudentInvoice.vue"
export default component.exports